import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Logout from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import SwapIcon from '@mui/icons-material/SwapHoriz'

const AccountMenu = ({anchorEl, handleClose, open, signOut, role, handleMode, mode, goToSettings}) => (
  <Menu
    anchorEl={anchorEl}
    id='account-menu'
    open={open}
    onClose={handleClose}
    onClick={handleClose}
    slotProps={{
      paper: {
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1
          },
          '&::before': {
            content: "''",
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0
          }
        }
      }
    }}
    transformOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
  >
    {
      role.name === 'admin' && (
        <MenuItem onClick={handleMode}>
          <ListItemIcon>
            <SwapIcon fontSize='small' />
          </ListItemIcon>
          {mode === 'user' ? 'Admin Dashboard' : 'Personal Dashboard'}
        </MenuItem>
      )
    }
    <MenuItem onClick={goToSettings}>
      <ListItemIcon>
        <SettingsIcon fontSize='small' />
      </ListItemIcon>
      Account Settings
    </MenuItem>
    <MenuItem onClick={signOut}>
      <ListItemIcon>
        <Logout fontSize='small' />
      </ListItemIcon>
      Logout
    </MenuItem>
  </Menu>
)

export default AccountMenu
